import React, { useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useTokenATH } from "../../../hooks/useTokenATH";
import NotifyMe from "../../NotifyMe/NotifyMe";
import Web3 from "web3";
import UnifiedCardTimer from "./UnifiedCardTimer";
import { useRoundData } from "./useRoundData";

const UnifiedCard = ({ project }) => {
  const { t } = useTranslation();
  const web3 = useMemo(() => new Web3(project.rpc), [project.rpc]);

  const [timeshow, setTimeshow] = useState(false);

  const { roundData } = useRoundData(project);

  // Fetch ATH price for ended projects
  const { price: athPrice } = useTokenATH(
    project.blockchain || "",
    project.contractAddress || ""
  );

  // Calculate ATH ROI for ended projects
  const calculateROI = () => {
    if (!athPrice || !project.initialPrice) return "TBD";
    const roi = parseInt(
      ((parseFloat(athPrice) - project.initialPrice) / project.initialPrice) *
        100
    );
    return `${roi}%+`;
  };

  // Render Coming Soon Card
  if (project.saleType === "comingsoon") {
    return (
      <div className="single-card">
        <Link to={project.link}>
          <div className="token-info">
            <div className="innner_token_info">
              <div className="main-token-img">
                <img
                  width={70}
                  height={70}
                  src={project.logo}
                  alt="img"
                  className="img-fluid"
                />
              </div>
              <div>
                <h6>
                  {project.name}{" "}
                  {project.verified && (
                    <span>
                      {" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="13"
                        height="12"
                        viewBox="0 0 13 12"
                        fill="none"
                      >
                        <path
                          d="M7.45048 0L8.48835 3.27474L12.1008 3.19729L12.7619 5.12326L9.79188 7.06969L10.9857 10.2962L9.2544 11.4857L6.38016 9.41358L3.50592 11.4857L1.77458 10.2962L2.96845 7.06969L0 5.1218L0.661029 3.19583L4.27352 3.27327L5.3114 0H7.45048Z"
                          fill="#05BADA"
                        />
                      </svg>
                      {t("Verifiedgems")}
                    </span>
                  )}
                </h6>
                <p className="sub-title">{project.symbol}</p>
              </div>
            </div>

            <p className="para">{project.description}</p>
          </div>
        </Link>
        <div
          className="round-info"
          style={{ borderBottom: "1px solid var(--border2)" }}
        >
          <h6>{t("Process-t4")}</h6>
          <h6 style={{ color: "#F3BA2F" }}>{t("Coming")}</h6>
        </div>
        <Link to={project.link} className="btn-buy">
          {t("Process-t7")}
        </Link>
        <NotifyMe
          className={`btn-green mb-0`}
          style={{ margin: "30px 0" }}
          privateSale={project.notifyName}
        />
      </div>
    );
  }

  // Render Live Card
  if (project.saleType === "live") {
    return (
      <div className="single-card">
        <Link to={project.link}>
         
          <div className="token-info">
            <div className="innner_token_info">
                 <div className="main-token-img">
            <img
              width={70}
              height={70}
              src={project.logo}
              alt="img"
              className="img-fluid"
            />
          </div>
          <div>
      <h6>
                {project.name}{" "}
                {project.verified && (
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="12"
                      viewBox="0 0 13 12"
                      fill="none"
                    >
                      <path
                        d="M7.45048 0L8.48835 3.27474L12.1008 3.19729L12.7619 5.12326L9.79188 7.06969L10.9857 10.2962L9.2544 11.4857L6.38016 9.41358L3.50592 11.4857L1.77458 10.2962L2.96845 7.06969L0 5.1218L0.661029 3.19583L4.27352 3.27327L5.3114 0H7.45048Z"
                        fill="#05BADA"
                      />
                    </svg>
                    {t("Verifiedgems")}
                  </span>
                )}
              </h6>
              <p className="sub-title">{project.symbol}</p>
          </div>
        
            </div>

            <p className="para">{project.description}</p>
          </div>
        </Link>
        <div className="tokenprice-info">
          <div className="text">
            <p>{t("Process-t4")}</p>
            <h6>{roundData?.round ?? project.round}</h6>
            {/* <h6>{project.round}</h6> */}
          </div>
          <div className="text">
            <p>{t("Process-t3")}</p>
            <h6>${roundData?.price ?? project.currentPrice}</h6>
            {/* <h6>{project.currentPrice}</h6> */}
          </div>
          <div className="text">
            <p>{t("Totalrasied")}</p>
            <h6>{project.totalRaised || "--"}</h6>
          </div>
        </div>
        <div
          className="round-info"
          style={{ borderBottom: "1px solid var(--border2)" }}
        >
          <UnifiedCardTimer
            project={project}
            startTime={roundData?.startTime ?? project?.startTime}
            endTime={roundData?.endTime ?? project?.endTime}
            timeshow={timeshow}
            setTimeshow={setTimeshow}
          />
        </div>
        {!timeshow ? (
          <Link to={project.link} className="btn-buy">
            {t("Process-t7")}
          </Link>
        ) : (
          <a
            href={`${project.buyLink}?utm_source=buyNow_landing`}
            target="_blank"
            className="btn-green"
          >
            {t("Btn-buynow")}
          </a>
        )}
      </div>
    );
  }
  // Render Live Card
  if (project.saleType === "paused") {
    return (
      <div className="single-card">
        <Link to={project.link}>
          
          <div className="token-info">
            <div className="innner_token_info">
                <div className="main-token-img">
            <img
              width={70}
              height={70}
              src={project.logo}
              alt="img"
              className="img-fluid"
            />
          </div>
          <div>
    <h6>
                {project.name}{" "}
                {project.verified && (
                  <span>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="12"
                      viewBox="0 0 13 12"
                      fill="none"
                    >
                      <path
                        d="M7.45048 0L8.48835 3.27474L12.1008 3.19729L12.7619 5.12326L9.79188 7.06969L10.9857 10.2962L9.2544 11.4857L6.38016 9.41358L3.50592 11.4857L1.77458 10.2962L2.96845 7.06969L0 5.1218L0.661029 3.19583L4.27352 3.27327L5.3114 0H7.45048Z"
                        fill="#05BADA"
                      />
                    </svg>
                    {t("Verifiedgems")}
                  </span>
                )}
              </h6>
              <p className="sub-title">{project.symbol}</p>
          </div>
          
            </div>

            <p className="para">{project.description}</p>
          </div>
        </Link>
        <div className="tokenprice-info">
          <div className="text">
            <p>{t("Process-t4")}</p>
            <h6>--</h6>
            {/* <h6>{project.round}</h6> */}
          </div>
          <div className="text">
            <p>{t("Process-t3")}</p>
            <h6>--</h6>
            {/* <h6>{project.currentPrice}</h6> */}
          </div>
          <div className="text">
            <p>{t("Totalrasied")}</p>
            <h6>{project.totalRaised || "--"}</h6>
          </div>
        </div>
        <div
          className="round-info "
          style={{ borderBottom: "1px solid var(--border2)" }}
        >
          <UnifiedCardTimer
            project={project}
            startTime={roundData?.startTime ?? project?.startTime}
            endTime={roundData?.endTime ?? project?.endTime}
            timeshow={timeshow}
            setTimeshow={setTimeshow}
          />
        </div>
        <Link to={project.link} className="btn-buy">
          {t("Process-t7")}
        </Link>
      </div>
    );
  }
  // Render Ended Card
  return (
    <div className="single-card">
      <Link to={project.link}>
        <div className="main-token-img">
          <img
            width={70}
            height={70}
            src={project.logo}
            alt="img"
            className="img-fluid"
          />
        </div>
        <div className="token-info">
          <div className="innner_token_info">
            <h6>
              {project.name}{" "}
              <span>
                {" "}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="12"
                  viewBox="0 0 13 12"
                  fill="none"
                >
                  <path
                    d="M7.45048 0.257202L8.48835 3.53194L12.1008 3.45449L12.7619 5.38046L9.79188 7.32689L10.9857 10.5534L9.2544 11.7429L6.38016 9.67079L3.50592 11.7429L1.77458 10.5534L2.96845 7.32689L0 5.379L0.661029 3.45303L4.27352 3.53048L5.3114 0.257202H7.45048Z"
                    fill="#30F1B6"
                  />
                </svg>
                {t("Verifiedgems")}
              </span>
              <span> {t("Completed")}</span>
            </h6>
            <p className="sub-title">{project.symbol}</p>
          </div>

          <p className="para">{project.description}</p>
        </div>
        <div className="tokenprice-info">
          <div className="text">
            <p>{t("privatesaleprice")}</p>
            <h6>{project.initialPrice}</h6>
          </div>
          <div className="text">
            <p>{t("alltimehigh")}</p>
            <h6>{athPrice || "TBD"}</h6>
          </div>
          <div className="text">
            <p>{project.athLabel || "ATH ROI"}</p>
            <h6 style={{ color: "var(--btn-green-bg)" }}>{calculateROI()}</h6>
          </div>
          {/* <div className="text">
                        <p>{t('Totalrasied')}</p>
                        <h6>{project.totalRaised}</h6>
                    </div> */}
        </div>
      </Link>
      <div className="round-info">
        <h6>{t("Totalrasied")}</h6>
        <h6>{project.totalRaised}</h6>
      </div>
      {/* <div className="round-info">
                <h6>{project.roundLabel || t('Process-t10')}</h6>
                <h6>{t('Finished')}</h6>
            </div> */}
      <Link to={project.link} className="btn-buy">
        {t("Process-t7")}
      </Link>
    </div>
  );
};

export default UnifiedCard;
